(function () {
    'use strict';

    function getSearchFieldDisplayValue() {
        return function (attributeData, searchFields) {

            for (var i = 0; i < searchFields.length; i++) {
                if (searchFields[i].Title == attributeData.Name) {

                    for (var j = 0; j < searchFields[i].Options.length; j++) {
                        if (searchFields[i].Options[j].Value == attributeData.Value) {
                            return searchFields[i].Options[j].Prompt;
                        }
                    }
                }
            }


            if (Array.isArray(attributeData.Value)) {
                return attributeData.Value.join(", ");
            }

            else if (typeof attributeData.Value == 'boolean') {
                return attributeData.Value ? 'Yes' : 'No';
            }

            return attributeData.Value;
        };
    }

    angular.module('ecap.common').filter('getSearchFieldDisplayValue', getSearchFieldDisplayValue);
})();